const remainingMonths = (data) => {
  // const currentDate = new Date();
  
  // const remainingMonthsData = data.filter(event => {
  //   const eventLastDate = new Date(event.date.match(/\b\w+\b\s\d+,\s\d{4}/)[0]);
  //   return eventLastDate > currentDate;
  // });
  
  // const monthsTextFormat = Object.keys(remainingMonthsData.reduce((acc, event) => {
  //   acc[event.month] = true;
  //   return acc;
  // }, {})).map(month => {
  //   const monthIndex = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"].indexOf(month);
  //   return monthIndex !== -1 ? ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][monthIndex] : null;
  // }).filter(month => month !== null);
  const months = {
    "January": 0,
    "February": 1,
    "March": 2,
    "April": 3,
    "May": 4,
    "June": 5,
    "July": 6,
    "August": 7,
    "September": 8,
    "October": 9,
    "November": 10,
    "December": 11
  };

  const currentDate = new Date();
  const currentMonth = currentDate.getMonth();  // getMonth() returns month index (0 for January, 1 for February, etc.)
  const currentDay = currentDate.getDate();

  const remainingMonthsData = data.filter(event => {
    const eventMonth = months[event.month];
    const eventDay = event.lastDate;

    if (eventMonth > currentMonth) {
      return true;
    }

    if (eventMonth === currentMonth && eventDay >= currentDay) {
      return true;
    }

    return false;
  }); 

return remainingMonthsData;
}


const eventsdata = [
     {
       title: "Governor’s Hurricane Conference",
       month :"May",
       lastDate:16,
       tooltipTitle:"Governor’s Hurricane...",
       date:`<p>Sun ,May  11, 2025 to <br> Fri, May 16,2025 </p>`,
       location: 'Palm Beach County Convention Center West Palm Beach, Florida',
       content: "The Governor’s Hurricane Conference focuses on hurricane planning ...",
       navlink:"https://domesticpreparedness.com/event/governors-hurricane-conference"
     },
     {
       title: "IAFC’s Community Risk Reduction  ...",
       month :"May",
       lastDate:15,
       tooltipTitle:"IAFC’s Community ...",
       date:`<p>Tue ,May 13, 2025 to<br> Thu, May 15, 2025 </p>`,
       location: 'Glendale, AZ',
       content: "The International Association of Fire Chief's (IAFC) Community Risk Reduction (CRR) Leadership Conference is geared specifically to the education and training needs of chief officers and other fire service managers […]",
       navlink:"https://domesticpreparedness.com/event/iafcs-community-risk-reduction-leadership-conference-2025"
     },
      {
       title: "Large Loss Mastery Training - Dallas",
       month :"May",
       lastDate:15,
       tooltipTitle:"Large Loss Mastery...",
       date:`<p>Tue,May 13, 2025 to <br> Thu, May 15, 2025</p>`,
       location: 'Arlington',
       content: "One of a kind training Large Loss Mastery Training course covers: Damage Assessment, Estimating, Critical Path Management, Scope of Work Creation...",
       navlink:"https://10times.com/e1d3-53x4-dxzg-k"
     },
     {
       title: "Secure360 Conference",
       month :"May",
       lastDate:15,
       tooltipTitle:"Secure360 Conference",
       date:`<p>Wed ,May 14, 2025 to  <br> Thu, May 15, 2025</p>`,
       location: 'Mystic Lake Center, Prior Lake, USA',
       content: "Secure360 is an all-encompassing experience that brings professionals...",
       navlink:"https://10times.com/secure360"
     },
   
   {
       title: "Certified DevSecOps Engineer (ECDE) - EC-Council",
       month :"May",
       lastDate:16,
       tooltipTitle:"Certified DevSecOps",
       date:`<p> Mon ,May 12, 2025 to <br> Fri, May 16, 2025</p>`,
       location: 'Chicago',
       content: "EDRP provides professionals with a strong understanding of business continuity and disaster recovery principles, including conducting business impact",
       navlink:"https://10times.com/e1hf-xf17-gk2f-8"
     },
     {
       title: "National VOAD 2025 Conference",
       month :"May",
       lastDate:22,
       tooltipTitle:"National VOAD 2025...",
       date:`<p>Mon, May 19, 2025 to <br> Thu, May 22, 2025</p>`,
       location: 'Louisville, KY',
       content: "National Voluntary Organizations Active in Disaster (VOAD) was founded over 50 years ago in response to the challenges many disaster organizations experienced following Hurricane Camille, a Category 5 storm that […]",
       navlink:"https://domesticpreparedness.com/event/national-voad-2025-conference"
     },
     {
       title: "Texas Emergency Management ...",
       month :"May",
       lastDate:30,
       tooltipTitle:"Texas Emergency...",
       date:`<p>Tue,May 27, 2025 to <br> Fri ,May 30, 2025</p>`,
       location: 'Ft. Worth Conference Center',
       content: "The Conference attracts over 3,500 elected officials, first responders, emergency managers, and decision makers from across Texas. This event provides a valuable opportunity for access to the latest technology, exchange […]",
       navlink:"https://domesticpreparedness.com/event/texas-emergency-management-conference-4"
     },
     {
       title: "5×5 The Public Safety Innovation ...",
       month :"June",
       lastDate:5,
       tooltipTitle:"5×5 The Public Safety...",
       date:`<p>Tue,June 3, 2025 to <br>Thu ,June 5, 2025</p>`,
       location: 'Bellevue, WA',
       content: "The summit brings together public safety, academia, government, and industry to help design the future of first responder communications. Test the latest innovations in public safety communications, see what is",
       navlink:"https://domesticpreparedness.com/event/5x5-the-public-safety-innovation-summit"
     },
     {
       title: "International Hazardous Materials Response...",
       month :"June",
       lastDate:15,
       tooltipTitle:"International Hazardous...",
       date:`<p>Thu, June 12, 2025 to <br>Sun, June 15, 2025</p>`,
       location: 'Hilton Baltimore',
       content: "The International Association of Fire Chiefs’ Hazmat Conference provides the classroom, hands-on, and field trip-based training that covers all aspects of hazmat, including transportation, safety, gear, terrorism, weapons of mass […]",
       navlink:"https://domesticpreparedness.com/event/international-hazardous-materials-response-teams-conference-2025-2"
     },
     {
       title: "United States Conference of Mayors...",
       month :"June",
       lastDate:25,
       tooltipTitle:"United States Conference...",
       date:`<p> Thu, June 19, 2025 to <br> wed ,June 25, 2025</p>`,
       location: 'Tampa, FL',
       content: "The United States Conference of Mayors is the official non-partisan organization of cities with populations of 30,000 or more. There are over 1,400 such cities in the country today. Each […]",
       navlink:"https://domesticpreparedness.com/event/united-states-conference-of-mayors-93rd-annual-meeting"
     },
     {
       title: "2025 NVFC Training Summit",
       month :"June",
       lastDate:21,
       tooltipTitle:"2025 NVFC Training...",
       date:`<p> Fri, June 20, 2025  to <br> Sat, June 21, 2025</p>`,
       location: 'Salt Lake City, UT',
       content: "The 2025 National Volunteer Fire Council Training Summit offers classroom-based training and collaborative opportunities for emergency responders from across the United States. Attendees can choose from breakout sessions organized into […]",
       navlink:"https://domesticpreparedness.com/event/2025-nvfc-training-summit"
     },
     {
       title: "The National Sheriffs’ Association... ",
       month :"June",
       lastDate:26,
       tooltipTitle:"The National Sheriffs...’",
       date:`<p>Mon ,June 23 ,2025 to <br>Thu, June 26 , 2025</p>`,
       location: 'Fort Lauderdale, FL',
       content: "The National Sheriff's Association Annual Conference includes a trade show displaying products and equipment relevant to every facet of police work, jails, prisoner transport, and courtroom security. This event features […]",
       navlink:"https://domesticpreparedness.com/event/the-national-sheriffs-association-annual-conference"
     },
     {
       title: "International Symposium on Animal...",
       month :"June",
       lastDate:2,
       tooltipTitle:"International Symposium ...",
       date:`<p>Sat, June 28 , 2025 to <br>wed, July 2 , 2025</p>`,
       location: 'Stevens Point, WI',
       content: "The International Symposium on Managing Animal Mortalities is a triennial symposium focusing on collaborating and sharing information to advance sustainable practices regarding animal mortalities. The first one was held in […]",
       navlink:"https://domesticpreparedness.com/event/international-symposium-on-animal-mortality-management"
     },
  
];
export const data = remainingMonths(eventsdata);
  // {
  //   title: 'Equal Justice Works Hosts Disaster Resilience...',
  //   tooltipTitle:"Equal Justice Works...",
  //   date:`<p>Fri, March 15, 2023, to <br>  Sat, March 16, 2023</p>`,
  //   location: 'Washington, D.C',
  //   content: 'Equal Justice Works, the nation’s largest facilitator of opportunities in public interest law, announced ...',
  //   navlink:"https://www.equaljusticeworks.org/news/equal-justice-works-hosts-disaster-resilience-symposium-with-community-partners/"
  // },
  // {
  //   title: '2022 Nevada Preparedness Summit',
  //   tooltipTitle:"2022 Nevada Preparedness...",
  //   date:`<p>Tue, February 22, 2022, to <br>  Fri, February 25, 2022</p>`,
  //   location: 'Las Vegas, Nevada',
  //   content: 'Registration is now open for the 2022 Nevada Preparedness Summit.',
  //   navlink:"https://preparenv.org/Summit"
  // },
  // {
  //   title: '2022 Colorado Emergency Management Conference',
  //   tooltipTitle:"2022 Colorado Emergency...",
  //   date:`<p>Tue, February 22, 2022, to <br>  Fri, February 25, 2022</p>`,
  //   location: 'Loveland, Colorado',
  //   content: 'The Colorado Emergency Management Association and the Colorado Division of Homeland Security …',
  //   navlink: "https://www.cemacolorado.com/"
  // },
  // {
  //   title: 'QSO Today Virtual Ham Expo',
  //   tooltipTitle:"QSO Today Virtual...",
  //   date:`<p>Sat , March 12, 2022, to <br>  Sun, March 13, 2022</p>`,
  //   location: 'Virtual',
  //   content: 'The Covid-19 Pandemic closed ham radio conventions, hamfests, and monthly meetings all across …',
  //   navlink: "https://www.qsotodayhamexpo.com/"
  // },
  // {
  //   title: '2022 IWCE Annual Conference',
  //   tooltipTitle:"2022 IWCE Annual...",
  //   date:`<p>Mon, March 21, 2022, to <br>  Thu, March 24, 2022</p>`,
  //   location: 'Las Vegas, Nevada',
  //   content: 'Connecting Critical Communications Professionals to Create a Safer, More Efficient and More …',
  //   navlink:"https://iwceexpo.com/"
  // },
  // {
  //   title: 'Virginia Emergency Management Symposium',
  //   tooltipTitle:"Virginia Emergency...",
  //   date:`<p>Mon, March 21, 2022, to <br>  Thu, March 24, 2022</p>`,
  //   location: ' Norfolk, Virginia',
  //   content: 'The Virginia Emergency Management Symposium is an annual event that is co-sponsored by …',
  //   navlink:"https://www.vemaweb.org/index.php?option=com_mc&view=404"
  // },
  // {
  //   title: '2022 IAFC Virtual Wildland Urban Interface Conference',
  //   tooltipTitle:"2022 IAFC Virtual...",
  //   date:`<p>Tue, March 22, 2022, to <br>  Thu, March 24, 2022</p>`,
  //   location: 'Reno, Nevada',
  //   content: 'Save the Date for the International Association of Fire Chiefs Wildland Urban Interface Conference..',
  //   navlink:"https://www.eventscribe.net/2021/WUI/"
  // },
  // {
  //   title: '2022 Joint Civil & DoD CBRN Symposium',
  //   tooltipTitle:"2022 Joint Civil...",
  //   date:`<p>Wed, March 23, 2022, to <br>  Thu, March 24, 2022</p>`,
  //   location: 'National Harbor, MD',
  //   content: 'The 10th Annual Joint Civil & DoD CBRN Symposium will provide a forum for members of the U.S. …',
  //   navlink: "https://jointcbrn.dsigroup.org/"
  // },
  // {
  //   title: '2022 IAEM Mid-Year Virtual Conference',
  //   tooltipTitle:"2022 IAEM Mid-Year...",
  //   date:`<p> Thu, March 24, 2022, to <br>   Fri, March 25, 2022</p>`,
  //   location: 'Virtual',
  //   content: 'IAEM is hosting a mid-year virtual conference, Mar. 24-25, 2022, to bring you two days of brand-new…',
  //   navlink: "https://www.iaem.org/Events/Event-Info/sessionaltcd/220324VIRTUAL-AC"
  // },
  // {
  //   title: 'Border Security Expo 2022',
  //   tooltipTitle:"Border Security...",
  //   date:`<p>Tue, March 29, 2022, to <br>  Wed, March 30, 2022</p>`,
  //   location: 'San Antonio, Texas',
  //   content: 'Held each year in San Antonio, Texas, Border Security Expo offers local, state, and federal law…',
  //   navlink:"https://www.bordersecurityexpo.com/"
  // },
  // {
  //   title: '2022 Preparedness Summit',
  //   tooltipTitle:"2022 Preparedness Summit",
  //   date:`<p>Sun, April 03, 2022, to <br>  Thu, April 07, 2022</p>`,
  //   location: 'Atlanta, Georgia',
  //   content: 'The Preparedness Summit is the first and longest-running national conference on public health…',
  //   navlink: "https://www.preparednesssummit.org/home"
  // },
  // {
  //   title: 'Hardwiring Resiliency Healthcare Conference',
  //   tooltipTitle:"Hardwiring Resiliency...",
  //   date:`<p>Mon, April 04, 2022, to <br>  Tue, April 05, 2022 </p>`,
  //   location: 'Boston, MA',
  //   content: 'The program engages people across departments to ensure their individual vitality and collective strength…',
  //   navlink: "https://www.hardwiringhealthcare.com/"
  // },
  // {
  //   title: 'Critical Infrastructure Protection & Resilience Americas',
  //   tooltipTitle:"Critical Infrastructure...",
  //   date:`<p>Wed, April 06, 2022,  to <br>  Fri, April 08, 2022</p>`,
  //   location: 'New Orleans, Louisiana',
  //   content: 'Critical Infrastructure Protection and Resilience North America brings together leading stakeholders…',
  //   navlink: "https://ciprna-expo.com/"
  // },
  // {
  //   title:'2022 National Hurricane Conference',
  //   tooltipTitle:"2022 National Hurricane...",
  //   date:`<p>Mon, April 11, 2022, to <br>  Thu, April 14, 2022</p>`,
  //   location:' Orlando, Florida',
  //   content:'The primary goal of the National Hurricane Conference is to improve hurricane preparedness, response…',
  //   navlink:" https://hurricanemeeting.com/"
  // },
  // {
  //   title:'ResCon International',
  //   tooltipTitle:"ResCon International",
  //   date:`<p>Tue, April 19, 2022, to <br>  Thu, April 21, 2022 </p>`,
  //   location:' New Orleans, LA',
  //   content:'ResCon is the premier annual international conference on the practice of successful resilience and disaster…',
  //   navlink:" https://resconnola.com/registration/"
  // },
  // {
  //   title:'2022 National VOAD Conference',
  //   tooltipTitle:"2022 National VOAD...",
  //   date:`<p>Mon, May 02, 2022, to <br>  Thu, May 05, 2022 </p>`,
  //   location:'Baltimore, MD',
  //   content:'Save the Date for the National Volunteer Organizations Active in Disaster Conference.',
  //   navlink:"https://www.nvoad.org/nvoadevents/2022-national-voad-conference/"
  // },
  // {
  //   title:"2022 Florida Governor's Hurricane Conference",
  //   tooltipTitle:"2022 Florida Governor's...",
  //   date:`<p>Sun, May 08, 2022, to <br>  Fri, May 13, 2022 </p>`,
  //   location:' Palm Beach, Florida',
  //   content:'The Governor’s Hurricane Conference (GHC) was established in order to provide a vehicle to present lessons…',
  //   navlink:"https://flghc.org/"
  // },
  // {
  //   title:'2022 Great Lakes Homeland Security Training Conference',
  //   tooltipTitle:"2022 Great Lakes...",
  //   date:`<p> Tue, May 10, 2022, to <br>  Thu, May 12, 2022 </p>`,
  //   location:' Grand Rapids, Michigan',
  //   content:'The expo brings together more than1,500 stakeholders for training, demonstrations, and networking relevant…',
  //   navlink:" https://www.michigan.gov/msp/divisions/emhsd/glhs"
  // },
  // {
  //   title:'2022 Texas Emergency Management Conference',
  //   tooltipTitle:"2022 Texas Emergency...",
  //   date:`<p> Tue, May 31, 2022, to <br>  Fri, June 03, 2022 </p>`,
  //   location:' San Antonio, TX',
  //   content:'Planning for the 2022 Texas Emergency Management Conference is underway.',
  //   navlink:"https://www.tdem.texas.gov/conference "
  // },
  // {
  //   title:'2022 National Fire Protection Association Conference and Expo',
  //   tooltipTitle:"2022 National Fire...",
  //   date:`<p>Mon, June 06, 2022, to <br>  Thu, June 09, 2022</p>`,
  //   location:' Boston, Massachusetts',
  //   content:'Planning is underway for NFPA Conference & Expo 2022.',
  //   navlink:" https://www.nfpa.org/conference/"
  // },   
  // {
  //   title:'International Hazardous Materials Response Teams Conference',
  //   tooltipTitle:"International Hazardous...",
  //   date:`<p> Thu, June 09, 2022, to <br> Sun, June 12, 2022</p>`,
  //   location:' Hilton Baltimore, Baltimore, Maryland',
  //   content:" Held each spring, the IAFC's Hazmat Conference provides the latest classroom, hands-on, and field trip…",
  //   navlink:"https://www.iafc.org/events/event/2022/06/09/default-calendar/international-hazardous-materials-response-teams-conference "
  // },
  // {
  //   title:'7th International Symposium on Animal Mortality Management',
  //   tooltipTitle:"7th International Symposium...",
  //   date:`<p>Mon, June 27, 2022, to <br>  Thu, June 30, 2022</p>`,
  //   location:' Raleigh, NC',
  //   content:' The International Symposium on Managing Animal Mortalities is a triennial symposium focusing on collaborating…',
  //   navlink:" https://www.animalmortmgmt.org/"
  // },
  // {
  //   title:'National Homeland Security Conference',
  //   tooltipTitle:"National Homeland...",
  //   date:`<p> Mon, July 11, 2022, to <br>  Thu, July 14, 2022 </p>`,
  //   location:' Cleveland, Ohio',
  //   content:'The 2022 Homeland Security Conference will host a great deal of dynamic content from July 11-14…',
  //   navlink:" https://www.nationalhomelandsecurity.org/"
  // },
  // {
  //   title:'2022 National Association of Counties Annual Conference',
  //   tooltipTitle:"2022 National Association...",
  //   date:`<p>Thu, July 21, 2022,  to <br>  Sun, July 24, 2022</p>`,
  //   location:' Adams County, Colorado',
  //   content:'Save the Date for the 2022 NaCo Annual Conference.',
  //   navlink:" "
  // },
  // {
  //   title:'2022 APCO International',
  //   tooltipTitle:"2022 APCO International",
  //   date:`<p> Sun, August 07, 2022 ,to <br> Wed, August 10, 2022 </p>`,
  //   location:'Anaheim, California',
  //   content:' Planning is underway for APCO 2022! Save the dates and keep checking the website for updates.',
  //   navlink:" https://www.apco2022.org/"
  // },
  // {
  //   title:'2022 Pennsylvania Association of Hazardous Materials Technicians',
  //   tooltipTitle:"2022 Pennsylvania Association...",
  //   date:`<p>Thu, August 25, 2022, to <br>  Sun, August 28, 2022</p>`,
  //   location:' Champion, PA',
  //   content:'Save the date for the 30th Annual Training & Education Conference.',
  //   navlink:" "
  // },
  // {
  //   title:'2022 American Public Health Association Annual Meeting',
  //   tooltipTitle:"2022 American Public...",
  //   date:`<p>Sun, November 06, 2022, to <br>  Wed, November 09, 2022 </p>`,
  //   location:' Boston, Massachusetts',
  //   content:'150 Years of Creating the Healthiest Nation: Leading the Path Toward Equity.',
  //   navlink:" https://www.apha.org/events-and-meetings/annual/past-and-future-annual-meetings"
  // },
  // {
  //   title:'2022 IAEM Annual Conference and EMEX',
  //   tooltipTitle:"2022 IAEM Annual...",
  //   date:`<p>Fri, November 11, 2022, to <br>  Thu, November 17, 2022</p>`,
  //   location:' Savannah, GA',
  //   content:'If you have to pick just one conference to attend this year, the 2022 IAEM 70th Annual Conference…',
  //   navlink:" https://www.iaem.org/usconf"
  // },
  // {
  //   title:'Natural Disaster & Emergency Management (NDEM) Expo 2022',
  //   tooltipTitle:"Natural Disaster...",
  //   date:`<p>Wed, November 16, 2022,  to <br>  Thu, November 17, 2022 </p>`,
  //   location:' New York, NY',
  //   content:'The Natural Disaster & Emergency Management (NDEM) Expo is a comprehensive trade…',
  //   navlink:" "
  // }
// ];
